module.exports = __webpack_public_path__ + "img/arrows-chevrons-right.c1f48352.svg";